import { z } from 'zod';
/** A required uuid of any version the client mints itself (crypto.randomUUID is v4), lower-cased so a retry matches. */
export const requiredClientGeneratedUuidString = (requiredMessage, invalidMessage) => z
    .string({ error: requiredMessage })
    .refine((value) => z.uuid().safeParse(value).success, invalidMessage)
    .transform((value) => value.toLowerCase());
//# sourceMappingURL=required-client-generated-uuid-string.js.map